import L from 'leaflet';
import iconRectRedImage from '../../../assets/map/marker/rectangle/red.png';
import iconRectCrimsonImage from '../../../assets/map/marker/rectangle/crimson.png';
import iconRectBlueImage from '../../../assets/map/marker/rectangle/blue.png';
import iconRectGreenImage from '../../../assets/map/marker/rectangle/green.png';
import iconRectYellowImage from '../../../assets/map/marker/rectangle/yellow.png';
import iconRectBrownImage from '../../../assets/map/marker/rectangle/orange.png';
import iconRectGreyImage from '../../../assets/map/marker/rectangle/grey.png';
import iconRectWhiteImage from '../../../assets/map/marker/rectangle/white.png';

const iconRectRed = new L.Icon({
  iconUrl: iconRectRedImage,
  iconSize: [8, 8],
});

const iconRectCrimson = new L.Icon({
  iconUrl: iconRectCrimsonImage,
  iconSize: [8, 8],
});

const iconRectBlue = new L.Icon({
  iconUrl: iconRectBlueImage,
  iconSize: [8, 8],
});

const iconRectGreen = new L.Icon({
  iconUrl: iconRectGreenImage,
  iconSize: [8, 8],
});

const iconRectYellow = new L.Icon({
  iconUrl: iconRectYellowImage,
  iconSize: [8, 8],
});

const iconRectBrown = new L.Icon({
  iconUrl: iconRectBrownImage,
  iconSize: [8, 8],
});

const iconRectGrey = new L.Icon({
  iconUrl: iconRectGreyImage,
  iconSize: [8, 8],
});

const iconRectWhite = new L.Icon({
  iconUrl: iconRectWhiteImage,
  iconSize: [8, 8],
});

const iconRect = {
  red: iconRectRed,
  crimson: iconRectCrimson,
  blue: iconRectBlue,
  green: iconRectGreen,
  yellow: iconRectYellow,
  brown: iconRectBrown,
  grey: iconRectGrey,
  white: iconRectWhite,
};

export default iconRect;
